module.exports = __webpack_public_path__ + "static/media/2-NN-Farger .c8390bc4.mp3";